
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/credentials",
      function () {
        return require("private-next-pages/user/credentials/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/credentials"])
      });
    }
  